
<ng2-smart-table class="table-responsive" [settings]="tabledata" [source]="data"> </ng2-smart-table>

